// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Formats minutes to hours with one decimal place and 'h' suffix
 */
export function formatHours(totalMinutes: number): string {
  const hours = totalMinutes / 60;
  return `${hours.toFixed(1)}h`;
}
